import axios from 'app/axiosInstance'

export const getThumbnails = ids => {
    return axios().get(`v1/files/$hdp?FileIds=${ids}`)
}

export const getIndicators = ({ ids, query = '' }) => {
    if (!ids.length)
        return Promise.reject({
            status: 400,
            message: 'No data to recache',
        })
    return axios().get(`v1/files/_annotation?FileIds=${ids}${query}`)
}
